/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import GradientButton from "../../Buttons/GradientButton/GradientButton";
import NftInteractionModal from "../NftInteractionModal/NftInteractionModal";
import StyledMdText from "../../../common/components/styledMdText/StyledMdText";
import StyledH4Heading from "../../../common/components/styledH4Heading/StyledH4Heading";

const EmailVerificationModal = ({
  closeModal,
  code,
  setCode,
  handleVerifyOtp,
  isPending,
  onResend
}) => {
  const [timer, setTimer] = useState(120);

  useEffect(() => {
    let intervalId;
    if (timer > 0) {
      intervalId = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } 
    return () => clearInterval(intervalId);
  }, [timer]);

  const handleResendClick = () => {
    setTimer(120);
    onResend()
  };


  const handleChange = (e) => {
    const value = e.target.value;
    if (value.length < 7) {
      setCode(value);
    }
  };
  const formattedMinutes = Math.floor(timer / 60);
  const formattedSeconds = timer % 60;

  return (
    <NftInteractionModal
      handleClose={closeModal}
      outsideClick={false}
      width={"w-[95%] sm:w-4/5 md:w-4/6 lg:w-1/2 xl:w-1/3"}
      content={
        <div className="w-full flex flex-col gap-5 p-5 sm:p-10">
          <div>
            <StyledH4Heading>Verify Your Email</StyledH4Heading>
            <StyledMdText>
              Please enter your one-time-password sent to your email address to
              verify your email.
            </StyledMdText>
          </div>

          <div className="space-y-1">
            <div className="flex items-center relative">
              <input
                value={code}
                onChange={handleChange}
                type="number"
                className="border border-bright-yellow rounded-md text-md py-2.5 px-4 flex-grow bg-transparent focus:outline focus:outline-bright-yellow"
                placeholder="Enter Verification Code"
              />
              <div className="absolute right-3 flex gap-2 items-center">
              {
                  timer !== 0 ?   <div className="text-md font-semibold text-bright-yellow">
                  {`${
                    formattedMinutes < 10
                      ? `0${formattedMinutes}`
                      : formattedMinutes
                  }:${
                    formattedSeconds < 10
                      ? `0${formattedSeconds}`
                      : formattedSeconds
                  }`}
                </div>
               
               : <button
                  className={`cursor-pointer text-bright-yellow`}
                  onClick={handleResendClick}
                >Resend</button>
                }
              </div>
            </div>

            <div className="flex justify-center items-center">
              <GradientButton
                fontColor={"w-[40%] mt-4"}
                children={"Verify Email"}
                onClick={handleVerifyOtp}
                disabled={code.length !== 6 || isPending}
              />
            </div>
          </div>
        </div>
      }
    />
  );
};

export default EmailVerificationModal;
